import React, { useState } from 'react'
import { string, arrayOf, func, object, bool, shape, number } from 'prop-types'

import { Table, Input, Button } from 'antd'
import { EditOutlined, CheckOutlined, DeleteOutlined } from '@ant-design/icons'
import { EditableCell, EditableRow } from './editableCell'
import styled from 'styled-components'
const { Search } = Input

const EditableDataTable = ({
	loading,
	dataSource,
	columns,
	placeholderSearch,
	onSearch,
	onChangePageNumber,
	pages,
	id,
	saveData,
	buttons,
	handleChangeColumnName,
	handleDeleteColumn,
}) => {
	const [search, setSearch] = useState('')
	const [editingColumn, setEditingColumn] = useState(null)
	const [newColumnName, setNewColumnName] = useState(null)

	const components = {
		body: {
			row: EditableRow,
			cell: EditableCell,
		},
	}

	const handleSave = (row) => {
		const currentTableItens = [...dataSource]
		const index = currentTableItens.findIndex((item) => row.key === item.key)
		const item = currentTableItens[index]

		saveData({ id: row.key, data: { ...item, ...row } })
	}

	const handleEditColumnName = (title) => {
		setEditingColumn(title)
		setNewColumnName(title)
	}

	const handleConfirmColumnName = () => {
		handleChangeColumnName(editingColumn, newColumnName)
		setEditingColumn(null)
	}

	const handleColumnNameChange = (e) => {
		setNewColumnName(e.target.value)
	}

	const editableColumns = columns.map((col) => {
		if (!col.editable) {
			return col
		}

		return {
			...col,
			onCell: (record) => ({
				record,
				editable: col.editable,
				dataIndex: col.dataIndex,
				title: col.title,
				handleSave,
			}),
			title:
				editingColumn === col.dataIndex ? (
					<EditingTableColumnHeader>
						<Input defaultValue={col.title} onChange={handleColumnNameChange} />
						<Button
							onClick={handleConfirmColumnName}
							icon={<CheckOutlined style={{ fontSize: '18px' }} />}
						/>
					</EditingTableColumnHeader>
				) : (
					<EditableTableColumnHeader>
						<span>{col.title}</span>
						<Button
							onClick={() => handleEditColumnName(col.dataIndex)}
							icon={<EditOutlined style={{ fontSize: '18px' }} />}
						/>
						<Button
							onClick={() => handleDeleteColumn(col.dataIndex)}
							icon={<DeleteOutlined style={{ fontSize: '18px' }} />}
						/>
					</EditableTableColumnHeader>
				),
		}
	})

	return (
		<>
			<div
				className="searchbox"
				style={{
					display: 'flex',
					gap: '6px',
					margin: '24px 0',
				}}>
				<Search
					placeholder={placeholderSearch}
					onSearch={(search) => onSearch({ page: 1, perPage: 10, search })}
					onChange={(e) => setSearch(e.target.value)}
					enterButton
					style={{ width: '30%' }}
					value={search}
				/>
				{buttons.map((buttonComponent) => buttonComponent)}
			</div>
			<Table
				loading={loading}
				components={components}
				columns={editableColumns}
				dataSource={dataSource}
				rowClassName={() => 'editable-row'}
				pagination={{
					showSizeChanger: true,
					pageSize: pages.per_page,
					position: ['bottomRight'],
					total: pages.total,
					current: pages.page,
					onShowSizeChange: (page, perPage) =>
						onChangePageNumber({ id, page, perPage, search }),
					onChange: (page, perPage) =>
						onChangePageNumber({ id, page, perPage, search }),
					locale: { items_per_page: '' },
				}}
			/>
		</>
	)
}

EditableDataTable.propTypes = {
	loading: bool,
	dataSource: arrayOf(object),
	columns: arrayOf(object),
	placeholderSearch: string,
	onSearch: func,
	onChangePageNumber: func,
	pages: shape({
		per_page: number,
		page: number,
		total: number,
	}).isRequired,
	id: number,
	saveData: func,
	buttons: arrayOf(object),
	handleChangeColumnName: func,
	handleDeleteColumn: func,
}

const EditableTableColumnHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: start;

	> span:first-child {
		margin-right: 8px;
	}

	> button {
		visibility: hidden;
		border: none;
		background-color: transparent;
		box-shadow: none;
	}

	&:hover {
		> button {
			visibility: visible;
			background-color: transparent;
		}
	}
`

const EditingTableColumnHeader = styled.div`
	display: flex;
	justify-content: start;

	> Input {
		width: 80%;
	}

	> button {
		border: none;
		background-color: transparent;
		box-shadow: none;
	}
`

export default EditableDataTable
